// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1rmIw","cell":"ColumnAccessor_cell__rt3Wh","firstCellAccent":"ColumnAccessor_firstCellAccent__1mUas"};